var exports = {
  "Sc": "UserArea.module__userAreaInnerWrapper___aThkNz",
  "cU": "UserArea.module__userAreaContainer___aThkNz",
  "jC": "UserArea.module__popoutContainer___aThkNz",
  "oT": "UserArea.module__voiceConnectionWrapper___aThkNz",
  "eF": "UserArea.module__userInfo___aThkNz",
  "vu": "UserArea.module__active___aThkNz",
  "N6": "UserArea.module__userInfoText___aThkNz",
  "nT": "UserArea.module__userName___aThkNz",
  "ag": "UserArea.module__userStatus___aThkNz",
  "uh": "UserArea.module__userStatusLabel___aThkNz" + " " + "UserArea.module__userStatus___aThkNz",
  "XW": "UserArea.module__userCustomStatus___aThkNz" + " " + "UserArea.module__userStatus___aThkNz",
  "oM": "UserArea.module__hoverRoll___aThkNz",
  "n6": "UserArea.module__defaultState___aThkNz",
  "yo": "UserArea.module__hovered___aThkNz",
  "EE": "UserArea.module__forceHover___aThkNz",
  "gO": "UserArea.module__controlsContainer___aThkNz",
  "uH": "UserArea.module__controlButton___aThkNz",
  "DY": "UserArea.module__contextMenuHover___aThkNz",
  "r9": "UserArea.module__disabled___aThkNz",
  "pd": "UserArea.module__controlIcon___aThkNz",
};

module.exports = exports;
